module.exports = __webpack_public_path__ + "img/no-account-button.241c44b0.png";